import React from 'react'
import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import WorkListViewStoreProviderRop from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import { WorkListView } from './components/WorkListView/WorkListView'

const WorkListViewRopMobile = props => (
  <WorkListViewStoreProviderRop {...props}>
    <PageContainerMobile>
      <WorkListView />
    </PageContainerMobile>
  </WorkListViewStoreProviderRop>
)

export default WorkListViewRopMobile
